export default __webpack_public_path__ + "static/media/030_corner1.last.79cd6b1e.avif";